"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findConfigPath = exports.loadConfig = void 0;
var load_config_1 = require("./load-config");
Object.defineProperty(exports, "loadConfig", { enumerable: true, get: function () { return load_config_1.loadConfig; } });
var find_config_path_1 = require("./find-config-path");
Object.defineProperty(exports, "findConfigPath", { enumerable: true, get: function () { return find_config_path_1.findConfigPath; } });
//# sourceMappingURL=index.js.map